import { PositionMapConfig } from './components/BranchOfficeForm';
import { CountryCodeEnum } from '../common/types';

export const getDefaultConfigToMap = (marketUsed: CountryCodeEnum): PositionMapConfig => {
	switch (marketUsed) {
		case CountryCodeEnum.URUGUAY:
			// Montevideo
			return {
				latitude: -34.9011,
				longitude: -56.1645,
				countryCodeRestrictToSearch: 'UY',
			};
		case CountryCodeEnum.PARAGUAY:
		case CountryCodeEnum.TN_ITAU_PY:
			// Asunción
			return {
				latitude: -25.2637,
				longitude: -57.5759,
				countryCodeRestrictToSearch: 'PY',
			};
		case CountryCodeEnum.COLOMBIA:
			// Bogotá
			return {
				latitude: 4.711,
				longitude: -74.0721,
				countryCodeRestrictToSearch: 'CO',
			};
		case CountryCodeEnum.BOLIVIA:
			// La Paz
			return {
				latitude: -16.5,
				longitude: -68.1193,
				countryCodeRestrictToSearch: 'BO',
			};
		default:
			// Valor por defecto: Montevideo
			return {
				latitude: -34.9011,
				longitude: -56.1645,
				countryCodeRestrictToSearch: 'UY',
			};
	}
};
